<template>
	<div v-if="this.customer">
		<menu-desktop :menuSelected="this.menuSelected" :customer="this.customer" />

		<menu-mobile :user="this.user" :menuSelected="this.menuSelected" :customer="this.customer" />
		<div class="container-right">
			<div class="barTop" :class="menuSelected.dashboard ? 'view' : 'bar-top-white'">
				<div class="logo-mobile" v-if="menuSelected.dashboard">
					<img src="@/assets/images/logo.jpg" />
				</div>
				<div class="menu-white" v-if="menuSelected.dashboard" @click="openMenu(true)">
					<img src="@/assets/images/menu-burger-alb.svg" />
				</div>

				<div class="mobile-nav">
					<div class="arrow-back" @click="goBack()">
						<img src="@/assets/images/arrow-back.svg" />
					</div>
					<div class="page-title">
						<h3>{{ "Dashboard" }}</h3>
					</div>
					<div class="menu-white" @click="openMenu(true)">
						<img src="@/assets/images/menu-burger-gri.svg" />
					</div>
				</div>
				<TopBar :user="this.user" />
			</div>

			<div class="content">
				<Dashboard :customer="this.customer" :user="this.user" />
			</div>
		</div>
		<!-- <div id="modal_popup_general_problem" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_general_problem', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p v-html="$t('generalErrorMessage')"></p>
			</div>
		</div> -->
		<div id="modal_popup_banking_hours" v-if="displayPopupBanking" class="modal-popup">
			<div class="modal-popup-content">
			<a @click="showOrHideFirstPopup('modal_popup_banking_hours')" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>			
				<p v-html="$t('bankingHoursMesage')"></p>
			</div>
		</div>
	</div>
</template>

<style scoped src="@/assets/styles/beneficiary.css"></style>

<script>

	import MenuDesktop from "@/components/company/customer/MenuDesktop.vue";
	import MenuMobile from "@/components/company/customer/MenuMobile.vue";
	import TopBar from "@/components/company/TopBar.vue";
	import Dashboard from "@/components/company/customer/Dashboard.vue";
	import Cookies from "js-cookie";

	export default {
		components: {
			MenuDesktop,
			MenuMobile,
			Dashboard,
			TopBar,
		},
		data() {
			return {
				user: null,
				customer: null,
				selectedCompany: null,
				menuSelected: {
					dashboard: true,
				},
			};
		},
		methods: {
			showOrHideFirstPopup(modal_id) {
      Cookies.set("firstBanking", true);
      this.showModalPopup(modal_id, false);
    },
		},
		created() {
			this.showModalPopup("modal_popup_loading", true);
			if (this.user == null) {
				this.user = this.getUserData();
			} else {
				this.showModalPopup("modal_popup_loading", false);
			}
			if (this.selectedCompany == null) {
				this.selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));;
			}
			this.customer = this.getCustomerData('dash c', this.selectedCompany.role);
			this.showModalPopup("modal_popup_general_problem", true);

		},
		computed: {
			dataLoaded() {
				return this.$store.state.customerDataLoaded;
			},
			displayPopupBanking(){
				return (!Cookies.get("firstBanking")) ;
			}
		},
		watch: {
			'$store.state.customerDataLoaded': {
				handler() {
					// update locally relevant data
					if (this.customer == null || this.user == null) {
						this.user = this.getUserData();
						this.selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));
						this.customer = this.getCustomerData('dash w', this.selectedCompany.role);
						this.showModalPopup("modal_popup_loading", false);
					}
				}
			}
		}
	};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<!-- <style scoped>
	#modal_popup_banking_hours {
		visibility: visible;

	}
</style> -->
